import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { currentDomain } from "../../utils/general-config";
import { DomainEnum } from "../../services/enum/environment-enum";
// import FilePreviewCard from "./FilePreviewCard";

const PdfPreviewModal = ({ isOpen, handleClose, clickNext }) => {
  const { t } = useTranslation();
  const isSignSimpli = currentDomain() === DomainEnum.SIGNSIMPLI;
  return (
    <>
      {isOpen && (
        <Transition.Root show={isOpen} as={Fragment}>
          <Dialog as="div" className="fixed inset-0 z-50 overflow-y-auto" onClose={() => {}}>
            <div className="flex items-center justify-center min-h-screen px-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0 bg-black/50 transition-opacity" />
              </Transition.Child>

              {/* Trick for vertical center */}
              <span className="inline-block h-screen align-middle" aria-hidden="true">
                &#8203;
              </span>

              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <div className="inline-block p-[2px] bg-rs-border-gradient w-full max-w-[600px] overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-lg">
                  <div className="px-6 py-10 bg-white rounded-lg">
                    {/* Close Button */}
                    {!isSignSimpli && (
                      <div className="absolute top-4 right-4">
                        <button
                          type="button"
                          onClick={() => handleClose(false)}
                          className="rounded-md text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-0"
                        >
                          <span className="sr-only">Close</span>
                          <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                        </button>
                      </div>
                    )}

                    <div className="flex justify-center mb-4">
                      <div className="flex items-center justify-center w-14 h-14 rounded-full">
                        {isSignSimpli ? (
                          <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="60" height="60" rx="30" fill="#1D7FFF" />
                            <path
                              d="M26.2793 31.4171L32.6579 37.7957L48.2502 22.2035"
                              stroke="#EAEBED"
                              strokeWidth="4.96"
                            />
                            <path d="M11.75 28.9372L20.2549 37.7965L35.8471 22.2042" stroke="white" strokeWidth="4.96" />
                          </svg>
                        ) : (
                          <img
                            className="check-icon"
                            src={process.env.PUBLIC_URL + "/static/images/double-check-circle-green.svg"}
                            width="180"
                            alt="check icon"
                          />
                        )}
                      </div>
                    </div>

                    {/* Title */}
                    <h2 className="text-center text-[36px] font-semibold text-gray-900">
                      {t("secure_simpli_content.great_work")}
                    </h2>
                    <h3 className="text-center text-xs md:text-base font-semibold text-gray-900">
                      {t("secure_simpli_content.essential_documents")}
                    </h3>

                    {/* Subtitle */}
                    <p className="mt-2 text-center text-sm text-[#687585]">
                      {t("secure_simpli_content.access_text1")} <br /> {t("secure_simpli_content.access_text2")}
                    </p>

                    {/* Action Buttons */}
                    <div className="mt-6 flex justify-center">
                      <button
                        id="verify-email"
                        type="button"
                        onClick={clickNext}
                        className="px-20 py-[15px] text-white leading-[120%] !font-rethink tracking-[2%] text-md md:text-xl font-bold rounded-[100px] bg-ps-reskin-radial hover:bg-hover-ps-reskin-radial uppercase transition-colors duration-1000 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        {t("secure_simpli_content.next")}
                      </button>
                    </div>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition.Root>
      )}
    </>
  );
};

export default PdfPreviewModal;
